// extracted by mini-css-extract-plugin
export default {"leftColumn__container":"LeftColumn_leftColumn__container__sHe8c"};